<script setup lang="ts">
	import { useAuthStore } from '@/stores'
	const authStore = useAuthStore()
</script>

<template>
	<a
		id="navbarDropdownUser"
		class="nav-link pe-0 ps-1"
		role="button"
		data-bs-toggle="dropdown"
		aria-haspopup="true"
		aria-expanded="false"
	>
		<div class="avatar avatar-xl">
			<img v-if="authStore.photoBlob" class="rounded-soft" :src="authStore.photoBlob" alt="user" />
			<span v-if="!authStore.photoBlob" class="rounded-soft" role="img" aria-label="Emoji">👤</span>
		</div>
	</a>
	<div class="dropdown-menu dropdown-caret dropdown-menu-end py-0" aria-labelledby="navbarDropdownUser">
		<div class="bg-white dark__bg-1000 rounded-2 py-2">
			<router-link v-if="authStore.authenticated" class="dropdown-item" to="/user"
				>Profile &amp; account
			</router-link>
			<div v-if="authStore.authenticated" class="dropdown-divider"></div>
			<router-link v-if="authStore.authenticated" class="dropdown-item" to="/logout">Logout</router-link>
			<router-link v-if="!authStore.authenticated" class="dropdown-item" to="/login">Login</router-link>
		</div>
	</div>
</template>
